// LayoutEffect.js
import React, { useEffect } from 'react';
import { useLayout } from './LayoutContext'; // Ajuste o caminho conforme necessário

const LayoutEffect = () => {
  const { layoutConfig } = useLayout();

  useEffect(() => {
    // Aplica a cor de fundo quando layoutConfig.backgroundColor muda
    document.body.style.backgroundColor = layoutConfig.backgroundColor;

    // Você pode adicionar mais efeitos de layout aqui se necessário

  }, [layoutConfig.backgroundColor]); // Dependências do useEffect

  return null; // Esse componente não renderiza nada visualmente
};

export default LayoutEffect;
